export const MAX_HOURS = 168;
export const MIN_HOURS = 4;
export const DEFAULT_HOURS = 24;